import { ComponentPropsWithRef, forwardRef } from 'react';
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react';

type ButtonProps = ChakraButtonProps;

const ButtonComponent = (
  { children, ...props }: ButtonProps,
  ref: ComponentPropsWithRef<'button'>['ref'],
) => (
  <ChakraButton ref={ref} loadingText="Processing..." {...props}>
    {children}
  </ChakraButton>
);

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ButtonComponent,
);
